import { IReqCreateReport } from '@/types/parcel/orders/reports.interface';

export const STATUS_V3 = [
  {
    value: '*',
    label: 'Todos los estatus',
  },
  {
    value: 'confirmed',
    label: 'Creado',
  },
  {
    value: 'readyToPickup',
    label: 'Lista para recolección',
  },
  {
    value: 'onRoadToPickup',
    label: 'En camino a recolección',
  },
  {
    value: 'collected',
    label: 'Orden recolectada',
  },
  {
    value: 'unsuccessfulPickup',
    label: 'Recolección fallida',
  },
  {
    value: 'stored',
    label: 'En almacén',
  },
  {
    value: 'onContainer',
    label: 'En contenedor',
  },
  {
    value: 'chargedToVehicle',
    label: 'Cargado a vehículo',
  },
  {
    value: 'onLinehaul',
    label: 'En transporte',
  },
  {
    value: 'onRoadToDelivery',
    label: 'En camino a entrega',
  },
  {
    value: 'delivered',
    label: 'Entrega confirmada',
  },
  {
    value: 'unsuccessfulDelivery',
    label: 'Entrega fallida',
  },
  {
    value: 'onRoadToReturn',
    label: 'En camino a devolución',
  },
  {
    value: 'returned',
    label: 'Orden devuelta',
  },
  {
    value: 'unsuccessfulReturn',
    label: 'Devolución fallida',
  },
  {
    value: 'damaged',
    label: 'Dañado',
  },
  {
    value: 'cancelled',
    label: 'Cancelado',
  },
];

export const initialStateReports: IReqCreateReport = {
  betweenDates: {
    finish: '',
    start: '',
  },
  note: '',
  status: [],
};

export const statusTranslation: Record<string, string> = {
  CREATED: 'Creado',
  PROCESSING: 'Procesando',
  PROCESSED: 'Procesado',
  ERROR: 'Error',
  NOT_DATA: 'Sin datos',
};

export const statusStyle: Record<string, string> = {
  CREATED: '#867af9',
  PROCESSING: '#43425D',
  PROCESSED: '#87C34A',
  ERROR: '#EC645E',
  NOT_DATA: '#FBC30E',
};
export const statusStyleBG: Record<string, string> = {
  CREATED: '#867AF91A',
  PROCESSING: '#43425D1A',
  PROCESSED: '#DCF3C280',
  ERROR: '#F6DDDC',
  NOT_DATA: '#F8EECF',
};
